
// src/component/FDVG/Facts.js
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import NoneAddedPopup from '../NoneAddedPopup';
import Table from '../Table';
import { addFact, updateFact, deleteFact } from '../../../../../reducers/JsonRuleEditor/RulesActions';

const headings = {
    id: "id",
    factName: "Fact Name",
    type: 'Type'
};

export default function Facts() {
    const [view, setView] = useState("list");
    const [searchText, setSearchText] = useState("");
    const dispatch = useDispatch();
    const currentRule = useSelector(state => state.JsonRulesEditorReducer.currentRule);
    const facts = currentRule.facts || [];
    const [displayFacts, setDisplayFacts] = useState(facts);
    const [addData, setAddData] = useState({ factName: '', type: 'string' });
    const [isEditing, setIsEditing] = useState(false);

    const handleSearch = () => {
        if (searchText === "") {
            setDisplayFacts(facts);
        } else {
            const filtered = facts.filter((el) =>
                el.factName?.toLowerCase().includes(searchText.toLowerCase())
            );
            setDisplayFacts(filtered);
        }
    };

    const handleView = (type) => {
        if (type === "list") {
            setIsEditing(false);
            setAddData({ factName: '', type: 'string' });
        }
        setView(type);
    };

    const handleViewFn = (type, data) => {
        if (type === "view") {
            setAddData({ id: data.id, factName: data.factName, type: data.type });
            setIsEditing(true);
            handleView("add");
        } else if (type === "delete") {
            dispatch(deleteFact(data.id));
        }
    };

    const handleInputChange = (e, field) => {
        setAddData(prev => ({
            ...prev,
            [field]: e.target.value
        }));
    };

    const handleAddFact = () => {
        if (!addData.factName.trim()) {
            alert('Fact name is required');
            return;
        }

        if (isEditing) {
            dispatch(updateFact(addData));
        } else {
            dispatch(addFact({ factName: addData.factName, type: addData.type }));
        }
        
        handleView("list");
    };

    return (
        <>
            {view === "list" ? (
                <div style={{ marginTop: '30px' }}>
                    <div className="row">
                        <div className="col-sm-2 col-xs-12">
                            <input 
                                type='text' 
                                className='form-control' 
                                onKeyDown={(e) => e.key === 'Enter' && handleSearch()} 
                                value={searchText} 
                                onChange={(e) => {
                                    setSearchText(e.target.value);
                                    if (e.target.value === '') handleSearch();
                                }} 
                                placeholder='Type here...' 
                            />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <button className='addbtn' onClick={() => handleView("add")}>
                                <i className="fa fa-plus" aria-hidden="true"></i>&nbsp;Add Facts
                            </button>
                        </div>
                    </div>
                    <hr />
                    <div>
                        {facts && facts.length > 0 ? (
                            <Table 
                                headingsObj={headings} 
                                DataArray={facts} 
                                includeView={true} 
                                includeDelete={true} 
                                handleViewFn={handleViewFn} 
                            />
                        ) : (
                            <NoneAddedPopup 
                                heading={"No Facts"} 
                                text={"There are no facts available in the selected ruleset."} 
                                buttonText={"Create Facts"} 
                                buttonFn={handleView} 
                            />
                        )}
                    </div>
                </div>
            ) : ''}
            
            {view === "add" ? (
                <div className='AddBox'>
                    <div className="row">
                        <div className="col-sm-6 col-xs-12">
                            <label htmlFor="factName">Name</label>
                            <input 
                                id="factName"
                                className='form-control' 
                                type='text' 
                                value={addData.factName} 
                                onChange={(e) => handleInputChange(e, "factName")} 
                            />
                        </div>
                        <div className="col-sm-6 col-xs-12">
                            <label htmlFor="factType">Type</label>
                            <select 
                                id="factType"
                                className='form-control' 
                                value={addData.type} 
                                onChange={(e) => handleInputChange(e, "type")}
                            >
                                <option value="string">String</option>
                                <option value="number">Number</option>
                                <option value="boolean">Boolean</option>
                                <option value="array">Array</option>
                                <option value="object">Object</option>
                            </select>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }}>
                        <button 
                            className='addbtn' 
                            style={{ padding: '12px 35px', marginRight: '15px' }}
                            onClick={handleAddFact}
                        >
                            {isEditing ? 'Update Fact' : 'Add Fact'}
                        </button>
                        <button 
                            className='addbtn cancelbtn' 
                            style={{ padding: '12px 35px' }} 
                            onClick={() => handleView("list")}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            ) : ''}
        </>
    );
}